export default __webpack_public_path__ + "static/media/hnh1.d7392d22.png";